import React from 'react';
import { object } from 'prop-types';
import { StyliticWidget, shopTheImageConfig } from '.';

const ShopTheImageWidget = ({ preferences = {}, featureFlags = {} }) => (
    <StyliticWidget
        config={shopTheImageConfig}
        showTitle={false}
        showLoader={false}
        preferences={preferences}
        featureFlags={featureFlags}
    />
);

ShopTheImageWidget.propTypes = { preferences: object, featureFlags: object };

export default ShopTheImageWidget;
